import { useGetHeaders } from "@hooks/useGetHeaders";
import { AccountDeactivation } from "@lib/constants/contentful";

export const useAccountDeactivationSectionHeaders = () => {
    const { title, deactivateLink } = useGetHeaders({
        microcopiesWithTitles: {
            title: AccountDeactivation.sectionTitle,
            deactivateLink: AccountDeactivation.deactivateLink,
        },
    });

    return {
        title,
        deactivateLink,
    };
};
